import React from 'react';
import NavPageLink from '../NavPageLink';
import '../CgmModulePage.css';
import '../CgmFilterToolbar.css';

function BackIcon() {
  return (
    <span className="go-back-icon-inline" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" aria-hidden="true">
        <path d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z" />
        <path d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z" />
      </svg>
    </span>
  );
}

export default function CgmModulePageLayout({
  crumb,
  title,
  subtitle,
  backTo = '/',
  children,
  className = '',
  wide = false,
}) {
  return (
    <div className={`cgm-module-page${wide ? ' cgm-module-page--wide' : ''}${className ? ` ${className}` : ''}`}>
      <div className="cgm-module-page__top">
        {crumb ? <p className="cgm-module-page__crumb">{crumb}</p> : null}
        <div className="cgm-module-page__topbar">
          <NavPageLink
            className="cgm-toolbar-btn cgm-toolbar-btn--back"
            to={backTo}
            title="Retour"
          >
            <BackIcon />
            Retour
          </NavPageLink>
        </div>
        {(title || subtitle) && (
          <header className="cgm-module-page__head">
            {title ? <h1 className="cgm-module-page__title">{title}</h1> : null}
            {subtitle ? <p className="cgm-module-page__subtitle">{subtitle}</p> : null}
          </header>
        )}
      </div>
      <div className="cgm-module-page__content">{children}</div>
    </div>
  );
}
